import * as Yup from 'yup';
import Input from '@yoweb/ui/components/form/Input';
import { Text } from '@yoweb/ui/components/typography';
import { Grid } from '@yoweb/ui/components/Grid';
import { I_DO_NOT_KNOW_ID } from '@poplar/constants/intake';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var getIntegerInitialValues = function getIntegerInitialValues(integerAnswer) {
  var _integerAnswer$answer, _integerAnswer$answer2, _integerAnswer$answer3;

  return (_integerAnswer$answer = integerAnswer === null || integerAnswer === void 0 ? void 0 : (_integerAnswer$answer2 = integerAnswer.answeredValue) === null || _integerAnswer$answer2 === void 0 ? void 0 : (_integerAnswer$answer3 = _integerAnswer$answer2.value) === null || _integerAnswer$answer3 === void 0 ? void 0 : _integerAnswer$answer3.toString()) !== null && _integerAnswer$answer !== void 0 ? _integerAnswer$answer : '';
};
export var getIntegerValidationSchema = function getIntegerValidationSchema(integerAnswer, isOptional, t) {
  var _integerAnswer$intVal, _integerAnswer$intVal2, _integerAnswer$intVal3, _integerAnswer$intVal4;

  var numberValidation = Yup.number().integer(t('validation.not-accepted', {
    ns: 'common'
  }));
  var minNumber = integerAnswer === null || integerAnswer === void 0 ? void 0 : (_integerAnswer$intVal = integerAnswer.intValidation) === null || _integerAnswer$intVal === void 0 ? void 0 : (_integerAnswer$intVal2 = _integerAnswer$intVal.minValue) === null || _integerAnswer$intVal2 === void 0 ? void 0 : _integerAnswer$intVal2.value;
  var maxNumber = integerAnswer === null || integerAnswer === void 0 ? void 0 : (_integerAnswer$intVal3 = integerAnswer.intValidation) === null || _integerAnswer$intVal3 === void 0 ? void 0 : (_integerAnswer$intVal4 = _integerAnswer$intVal3.maxValue) === null || _integerAnswer$intVal4 === void 0 ? void 0 : _integerAnswer$intVal4.value;

  if (typeof minNumber === 'number') {
    numberValidation = numberValidation.min(minNumber, t('validation.min-number', {
      ns: 'common',
      min: minNumber,
      name: integerAnswer === null || integerAnswer === void 0 ? void 0 : integerAnswer.inputFieldHint
    }));
  }

  if (typeof maxNumber === 'number') {
    numberValidation = numberValidation.max(maxNumber, t('validation.max-number', {
      ns: 'common',
      max: maxNumber,
      name: integerAnswer === null || integerAnswer === void 0 ? void 0 : integerAnswer.inputFieldHint
    }));
  }

  return Yup.number().when(I_DO_NOT_KNOW_ID, {
    is: true,
    then: numberValidation,
    otherwise: isOptional ? numberValidation : numberValidation.required(t('validation.required', {
      ns: 'common'
    }))
  });
};
export var IntegerElement = function IntegerElement(_ref) {
  var _integerAnswer$intVal5, _integerAnswer$intVal6, _integerAnswer$intVal7, _integerAnswer$intVal8, _integerAnswer$inputF;

  var instructionHint = _ref.instructionHint,
      integerAnswer = _ref.integerAnswer,
      isDisabled = _ref.isDisabled,
      id = _ref.id;
  var minNumber = integerAnswer === null || integerAnswer === void 0 ? void 0 : (_integerAnswer$intVal5 = integerAnswer.intValidation) === null || _integerAnswer$intVal5 === void 0 ? void 0 : (_integerAnswer$intVal6 = _integerAnswer$intVal5.minValue) === null || _integerAnswer$intVal6 === void 0 ? void 0 : _integerAnswer$intVal6.value;
  var maxNumber = integerAnswer === null || integerAnswer === void 0 ? void 0 : (_integerAnswer$intVal7 = integerAnswer.intValidation) === null || _integerAnswer$intVal7 === void 0 ? void 0 : (_integerAnswer$intVal8 = _integerAnswer$intVal7.maxValue) === null || _integerAnswer$intVal8 === void 0 ? void 0 : _integerAnswer$intVal8.value;
  return /*#__PURE__*/_jsxs(Grid, {
    rowGap: "small2",
    children: [instructionHint && /*#__PURE__*/_jsx(Text, {
      size: "md",
      children: instructionHint
    }), /*#__PURE__*/_jsx(Input, {
      id: id,
      name: id,
      type: "number",
      min: minNumber,
      max: maxNumber,
      label: (_integerAnswer$inputF = integerAnswer === null || integerAnswer === void 0 ? void 0 : integerAnswer.inputFieldHint) !== null && _integerAnswer$inputF !== void 0 ? _integerAnswer$inputF : '',
      disabled: isDisabled
    })]
  });
};